import * as React from 'react';
import { withRouter } from 'react-router';
const withEximType = (Component) => {
  return withRouter(class WithEximType extends React.PureComponent<any, any> {

    getEximType = () => {
      const arr = this.props.location.pathname.split('/');
      arr.shift();
      if (arr[0] !== 'export' && arr[0] !== 'import') {
        return '';
      }
      return arr[0];
    }

    render() {
      const eximType = this.getEximType();
      return <Component {...this.props} eximType={eximType} isExports={eximType === 'export'} />;
    }
  });
};

export default withEximType;
